import axios from 'axios'
import { useState } from 'react'
import { apiStatus } from '../constants/apiStatus'
import { apiUrl, baseUrl, stage } from '../constants/apiUrl'
import { loadStatus } from '../constants/loadStatus'
import { errorMsg } from '../constants/messages'
import type { ResultVersionInfo } from '../interfaces/VersionIf'

interface CC01VersionGetProps {
  execVersionGet: () => Promise<ResultVersionInfo>
  loading: loadStatus
}
// CC01 バージョン情報取得API呼出
export const useCC01VersionGet = (): CC01VersionGetProps => {
  const [loading, setLoading] = useState(loadStatus.NONE)
  const execVersionGet = async () => {
    try {
      setLoading(loadStatus.LOADING)
      const response = await axios.get(`${baseUrl}${stage}${apiUrl.versionPath}`, {
        validateStatus: () => true,
      })
      if (response.status === apiStatus.SUCCESS) {
        setLoading(loadStatus.LOADED)
        return { success: true, info: response.data }
      }
      setLoading(loadStatus.LOADED)
      if (response.data && response.data.message) {
        return { success: false, message: response.data.message }
      }
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    } catch (error) {
      console.log(error)
      setLoading(loadStatus.LOADED)
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    }
  }
  return { execVersionGet, loading }
}
